import { makeStyles } from "@material-ui/core/styles";

export const useTablesStyle = makeStyles((theme) => ({
  paginationRoot: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  tableContainer: {
    Width: "100%",
  },
  tooltip: {
    backgroundColor: theme.palette.background.default,
    color: "#333",
    boxShadow: "0 0 3px #a3a3a3",
    fontSize: "13px",
    padding: "10px",
    borderRadius: "10px",
  },
  TableRow: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",

    borderBottom: `1px solid #E8E8EF `,
  },
  TableCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0",
    overflow: "hidden",
    borderBottom: "unset",
  },
  Avatar: {
    width: theme.spacing(3),
    paddingTop: theme.spacing(0.5),
    height: theme.spacing(3),
    fontSize: "15px",
    color: "#333",
    backgroundColor: "rgba(57, 20, 254,0.1)",
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  SortableTableHead: {
    width: "100%",
  },

  TablePaginationSelect: {
    boxShadow: `0 0 5px ${theme.palette.primary.main}`,
    borderRadius: "20px",
  },
  TablePaginationActions: {
    color: "#1E91C2",
    display: "flex",
    flexDirection: "row",
    marginLeft: theme.spacing(2),
  },
  stateColumn: {
    color: "white",
    padding: "1px 5px 1px 5px",
    borderRadius: "50px",
    width: "90%",
    textAlign: "center",
    opacity: "0.7",
  },

  AccordionSummary_root: {
    borderBottom: "unset",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  AccordionSummary_content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },

  Accordion_root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
}));
